<template>
  <div class="tripDetail">
    <!--    <ld-header>{{ $t('Details','出差申请单详情') }}</ld-header>-->
    <van-nav-bar
      title="出差申请单详情"
      left-arrow
      @click-left="back"
      class="khto"
    />
    <div class="wrapper">
      <mescroll-vue
        ref="mescroll"
        :down="down"
      >
        <div class="pad-t-5">
          <van-cell v-if="allData.status != 1 && allData.status != 2 && allData.status != 3">
            {{ allData.status | status }}
          </van-cell>
          <div class="wrapper">
            <mescroll-vue
              ref="mescroll"
              :down="{use:false}"
            >
              <div class="pad-b-50">
                <div>
                  <ul>
                    <li>
                      <van-field
                        readonly
                        clickable
                        name="picker"
                        :value="value"
                        label="行程类型"
                        placeholder="点击选择行程类型"
                        right-icon="arrow"
                        color="#000"
                        input-align="right"
                      />
                    </li>
                  </ul>
                  <ul>
                    <li>
                      <van-field
                        readonly
                        clickable
                        name="picker"
                        :value="Departurecity"
                        label="出发城市"
                        placeholder="出发城市"
                        right-icon="arrow"
                        color="#000"
                        input-align="right"
                      />
                    </li>
                    <li>
                      <van-field
                        v-if="roundtrip_chengshi"
                        readonly
                        clickable
                        name="picker"
                        :value="Arriveinthecity"
                        label="目的地"
                        placeholder="目的地"
                        right-icon="arrow"
                        color="#000"
                        input-align="right"
                      />
                    </li>
                    <li>
                      <van-field
                        v-if="roundtrip_chufariqi"
                        readonly
                        clickable
                        name="picker"
                        :value="Departuredate"
                        label="出发日期"
                        placeholder="出发日期"
                        right-icon="arrow"
                        color="#000"
                        input-align="right"
                      />
                    </li>
                  </ul>
                  <!--            多程的行程-->
                  <div
                    v-if="Multipletravelmodules"
                    v-for="(item,index) in apply.Multireach"
                    :key="index++"
                  >
                    <ul>
                      <li>
                        <van-field
                          readonly
                          clickable
                          name="picker"
                          :value="item.destination"
                          :label="'第'+ index+'程目的地'"
                          placeholder="目的地"
                          right-icon="arrow"
                          color="#000"
                          input-align="right"
                        />
                      </li>
                      <li v-if="index > 1">
                        <van-field
                          v-if="roundtrip_chufariqi"
                          readonly
                          clickable
                          name="picker"
                          :value="item.Departuredate"
                          label="出发日期"
                          placeholder="出发日期"
                          right-icon="arrow"
                          color="#000"
                          input-align="right"
                        />
                      </li>
                    </ul>
                    <ul v-if="roundtripcontrol">
                      <li style="display: flex;align-items: center;">
                        <van-field
                          :label="$t('出差事由')"
                          clearable
                          style="width: 100px"
                        />
                        <input
                          placeholder="请输入出差原因"
                          class="kh-sy"
                          type="text"
                          :value="ccsy"
                        >
                      </li>
                      <li style="display: flex;align-items: center;">
                        <van-field
                          readonly
                          clickable
                          name="picker"
                          label="项目出差 "
                          color="#000"
                          style="width: 345px"
                        />
                        <van-switch
                          size="15px"
                          v-model="checked1"
                          active-color="#7557e6"
                          inactive-color="#dcdee0"
                        />
                      </li>
                      <li v-if="checked1">
                        <van-field
                          readonly
                          clickable
                          name="picker"
                          :value="projectName"
                          label="项目名称"
                          placeholder="请选择项目名称"
                          right-icon="arrow"
                          color="#000"
                          input-align="right"
                        />
                      </li>
                      <li
                        v-if="checked1"
                        v-show="false"
                      >
                        <van-field
                          readonly
                          clickable
                          name="picker"
                          :value="0"
                          label="费用承担"
                          placeholder="费用承担"
                          right-icon="arrow"
                          color="#000"
                          input-align="right"
                        />
                      </li>
                    </ul>
                  </div>

                  <ul v-if="businesstrip">
                    <li>
                      <van-field
                        readonly
                        clickable
                        name="picker"
                        :value="Departuredate"
                        label="出发日期"
                        placeholder="出发日期"
                        right-icon="arrow"
                        color="#000"
                        input-align="right"
                      />
                    </li>
                  </ul>

                  <!--            往返日期-->
                  <ul v-if="roundt">
                    <li>
                      <van-field
                        readonly
                        clickable
                        name="picker"
                        :value="Departuredate"
                        label="出发日期 "
                        placeholder="出发日期 "
                        right-icon="arrow"
                        color="#000"
                        input-align="right"
                      />
                    </li>
                    <li>
                      <van-field
                        readonly
                        clickable
                        name="picker"
                        :value="Checkindate"
                        label="返程日期"
                        placeholder="返程日期"
                        right-icon="arrow"
                        color="#000"
                        input-align="right"
                      />
                    </li>
                  </ul>
                  <!--            酒店-->
                  <ul v-if="businesstrip">
                    <li style="display: flex;align-items: center;">
                      <van-field
                        readonly
                        clickable
                        name="picker"
                        label="出差住宿"
                        color="#000"
                        style="width: 345px"
                      />
                      <van-switch
                        size="15px"
                        v-model="checked"
                        active-color="#7557e6"
                        inactive-color="#dcdee0"
                      />
                    </li>
                  </ul>
                  <ul v-if="checked">
                    <li>
                      <van-field
                        readonly
                        clickable
                        name="picker"
                        :value="Checkindate"
                        label="入住日期"
                        placeholder="入住日期"
                        right-icon="arrow"
                        color="#000"
                        input-align="right"
                      />
                    </li>
                    <li>
                      <van-field
                        readonly
                        clickable
                        name="picker"
                        :value="Checkoutdate"
                        label="离店日期"
                        placeholder="离店日期"
                        right-icon="arrow"
                        color="#000"
                        input-align="right"
                      />
                    </li>
                  </ul>
                  <!--            出差项目-->
                  <ul v-if="roundtripisby">
                    <li style="display: flex;align-items: center;">
                      <van-field
                        :label="$t('出差事由')"
                        clearable
                        style="width: 100px"
                      />
                      <input
                        placeholder="请输入出差原因"
                        class="kh-sy"
                        type="text"
                        :value="ccsy"
                        disabled
                      >
                    </li>
                    <li style="display: flex;align-items: center;">
                      <van-field
                        readonly
                        clickable
                        name="picker"
                        label="项目出差 "
                        color="#000"
                        style="width: 345px"
                      />
                      <van-switch
                        size="15px"
                        v-model="checked1"
                        active-color="#7557e6"
                        inactive-color="#dcdee0"
                      />
                    </li>
                    <li v-if="checked1">
                      <van-field
                        readonly
                        clickable
                        name="picker"
                        label="项目名称"
                        placeholder="请选择项目名称"
                        :value="projectName"
                        right-icon="arrow"
                        color="#000"
                        input-align="right"
                      />
                    </li>
                    <!--              添加多个行程的按钮-->

                    <li
                      v-if="checked1"
                      v-show="false"
                    >
                      <van-field
                        readonly
                        clickable
                        name="picker"
                        :value="5"
                        label="费用承担"
                        placeholder="费用承担"
                        right-icon="arrow"
                        color="#000"
                        input-align="right"
                      />
                    </li>
                  </ul>
                  <ul>
                    <li>
                      <div>
                        <approval
                          v-if="allData.ccsqdNo"
                          :order-id="orderId"
                          :spgz-id="allData.appId"
                          :vip-status="allData.status"
                          order-type="11099"
                          element=".tripDetail"
                          style="color: #787890;"
                        />
                      </div>
                    </li>
                  </ul>
                </div>
                <div />
              </div>
            </mescroll-vue>
          </div>
        </div>
      </mescroll-vue>
    </div>
  </div>
</template>
<script>
import {Cell, Field, Popup, Picker, NavBar, Button, Switch} from 'vant'
import approval from 'Components/approval/approval'
import MescrollVue from 'mescroll.js/mescroll.vue'
import route from './components/route'
import Business from '@/business/utils/business'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import ldButton from 'Common/ldButton'
import {formatDate} from 'Utils/dateUtil'

export default {
  name: 'DetailsApplications',
  provide: {
    orderType: $dict.ORDER_TYPE.vipCcsqd
  },
  components:{
    [Cell.name]:Cell,
    [Field.name]:Field,
    [Popup.name]:Popup,
    [Picker.name]:Picker,
    [NavBar.name]:NavBar,
    [Button.name]:Button,
    [Switch.name]:Switch,
    ldTabbar,
    ldButton,
    approval,
    MescrollVue,
    route
  },
  data: function() {
    return {
      ccsy:'',
      projectName:'',
      gzmc:'',
      ApplicationFormDetails:'',//申请单详情数据
      down:{use:false},
      allData: {}, //
      allRouteList: [], //
      status: '', //审批进度
      index:'',
      appl:'',
      apply:{
        Multireach:[

        ],
      },
      button:false,
      roundtripcontrol:false,//区分往返的事由
      Multipletravelmodules:false,//多个行程的模块
      roundtripisby:true,//往返 多个行程的模块
      roundtrip_chufariqi:false,//出发日期
      roundtrip_chengshi:true,//出发日期
      roundt:false,
      businesstrip:true,
      dateType: 'single',
      roundtrip: 0,
      ateType: null,
      startDate: new Date(),
      departDate: formatDate(new Date(), 1),//出发时间
      arriveDate: {},//回程时间 formatDate(new Date(),2)
      minDate: '',
      maxDate: '',
      cplx1: '10901',
      // roundtrip: 0, // 0 单程 1 往返 2需求单
      way: 1, //1 出发城市  2到达城市
      Departuredate:'',
      Departurecity:'',
      Arriveinthecity:'',
      Total:'',
      Checkindate:'',
      Checkoutdate:'',
      checked: false,
      checked1: true,
      value: '',
      columns: ['单程', '往返', '多程'],
      radio:false,
      subjectCode:{
        show:false,
        must:false,
        write:false
      },
      jp:[{}],
      jd:[{}],
    }
  },
  props:{
    id:{
      type:String,
      default:''
    },
    priceList: {
      type: [Array, Object],
      default: function() {
        return []
      }
    }
  },
  computed:{
    orderId(){
      return this.$route.query.ccsqdId || this.id
    }
  },
  async created() {
    this.getSuccessData()
  },

  methods: {
    back(){
      this.$router.replace({path:'/khList'})
    },
    // 选择类型回调
    onConfirm(value) {
      console.log(value)
    },
    //获取数据
    getSuccessData() {
      this.$api['common/vipCcsqdGetInfo']({
        ccsqdId: this.orderId
      }).then(resp => {
        this.allData = resp.data||{}
        this.allRouteList = this.allData.allRouteList
        this.allRouteList.forEach(arr => {
          console.log(arr,'详情')
          arr.forEach(o => {
            o.spzt = this.allData.status == 2
          })
        })
      })
    },
    async revertApproval () {
      await Business.ApprovalRevert({
        orderId: this.orderId,
        orderType: '11099'
      })
      this.getSuccessData()
    }
  },
  filters:{
    status(val){
      let obj=['草稿','审批中','审批通过','审批拒绝','已删除','报销中','已报销']
      return obj[val]||''
    }
  },
  watch:{
    allData(val){
      this.remark = val.remark
      this.ApplicationFormDetails =  JSON.parse(val.mdd).Departurecity
      // 行程类别
      if(val.remark == 1){
        console.log(this.remark)
        this.value = '单程'
        this.businesstrip = true
        // 判断是否自动打开酒店开关
        if(this.Departuredate==''){
          this.checked = false
        }else{
          this.checked = true
        }
        this.Departurecity =JSON.parse(val.mdd).Departurecity
        this.Arriveinthecity = JSON.parse(val.mdd).Arriveinthecity
        this.Departuredate = JSON.parse(val.mdd).Departuredate
        this.Checkoutdate = JSON.parse(val.mdd).Checkoutdate
        this.Checkindate = JSON.parse(val.mdd).Checkindate
        this.ccsy = this.allData.ccsy
        this.projectName = this.allData.projectName
        this.businesstrip = true
        this.roundt = false
        this.roundtrip_chengshi = true
        this.roundtrip_chufariqi = false
        this.roundtripisby = true//打开往返事由
        this.Multipletravelmodules= false//关闭多程模块替换
        this.roundtripcontrol = false
        this.button = false
      }else if(val.remark == 2){
        this.value = '往返'
        this.Departurecity =JSON.parse(val.mdd).Departurecity
        this.Arriveinthecity = JSON.parse(val.mdd).Arriveinthecity
        this.Departuredate = JSON.parse(val.mdd).Departuredate
        this.Checkoutdate = JSON.parse(val.mdd).Checkoutdate
        this.Checkindate = JSON.parse(val.mdd).Checkindate
        this.ccsy = this.allData.ccsy
        this.projectName = this.allData.projectName
        this.businesstrip = false
        this.roundt = true
        this.roundtrip_chengshi = true
        this.roundtrip_chufariqi = false
        this.roundtripisby = true//打开往返事由
        this.Multipletravelmodules= false//关闭多程模块替换
        this.roundtripcontrol = false
        this.button = false
      }else if(val.remark == 3){
        this.value = '多程'
        this.apply.Multireach = JSON.parse(val.mdd)
        this.ccsy = this.allData.ccsy
        this.projectName = this.allData.projectName
        this.roundtrip_chengshi = false
        this.roundtrip_chufariqi = true
        this.businesstrip = false
        this.roundtripisby = false//打开往返事由
        this.Multipletravelmodules= true//打开多程模块替换
        this.roundtripcontrol = true
        this.button = true
        this.Departurecity = JSON.parse(val.mdd)[0].Departurecity1
        this.Departuredate = JSON.parse(val.mdd)[0].Departuredate1
      }
    }
  },
}
</script>
<style lang="less" scoped>

.pad-t-5{
    padding-top: 5px;
}
.wrapper {
    height: calc(100vh - 46px);
    overflow: hidden;
}
.pad-b-50{
  padding-bottom: 60px;
  div{
    ul{
      margin: 10px 10px 10px 10px;
      background-color: rgba(171, 171, 209, 0.2);
      border-radius: 5px;
      li{

      }
    }
    ul:nth-child(2){
      height:100%;
      background-color: rgba(171, 171, 209, 0.2);
      li:nth-child(1){
        border-bottom: 1px solid #fff;

      }
      li{
        span{
          border-bottom: 1px solid #fff;
        }
      }
    }
  }
}
.khbutton{
  width: 66px;
  height: 30px;
  border-radius: 12px;
  border:none;
  background: linear-gradient(270deg, rgba(111, 113, 237, 1) 13%, rgba(118, 80, 228, 1) 92%, rgba(118, 78, 228, 1) 96%);
}
.khdis{
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;

  button{
    margin:0 0 0 0
  }
}
.khbutton1{
  width: 66px;
  height: 30px;
  border-radius: 12px;
  border: 1px solid #6f70ed;
  color: #6f70ed;
}
/deep/ .van-field__control--right{
  font-size: 12px;
  color: #656464;
  font-weight: 400;
}

.roundtripbutton{
  background-color: rgba(56, 99, 208, 1);border: none;width: 394px;height: 40px;margin: 5px 0px 5px 10px;
}
/deep/ .van-cell{
  background-color: #fff0;
}
.kh-sy{
  width: 225px;
  height: 40px;
  background: #e0e0ef;
  text-align: center;
  border-radius: 5px;
  border: none;
}
.khto{
  background-color: rgba(130, 130, 171, 1);
  color: #fff;
}
</style>

